import React from "react";

import { QueryAwait, type QueryAwaitProps } from "@steto-care/steto-query";

import { AtomProps } from "@/uiKit/atoms/utils/AtomTypes.ts";

export type BaseSuspenseWithErrorProps = QueryAwaitProps;

export type SuspenseWithErrorProps = AtomProps<BaseSuspenseWithErrorProps>;

/**
 * Try renaming QueryAwait for more clarity
 */
export const SuspenseWithError: React.FC<SuspenseWithErrorProps> = ({ id, children, ...props }) => {
  return <QueryAwait {...props}>{children}</QueryAwait>;
};
